module.exports = __webpack_public_path__ + "img/icon_3_11.794011a0.png";